export const toggleActivity = {
  bind(el, binding, vnode) {
    el.addEventListener('click', () => {
      const ref = vnode.context.$refs[binding.value]
      const $s = ref[0]
      if ($s) {
        if ($s.classList.contains('is-active')) {
          $s.classList.remove('is-active')
        } else {
          $s.classList.add('is-active')
        }
      }
    })
  },
}

export const hoverSimulate = {
  bind(el, binding, vnode) {
    el.addEventListener('mouseover', () => {
      const siblings = Array.from(vnode.elm.offsetParent.children)
      siblings.forEach(item => item.firstChild.classList.remove('is-active'))
      if (!binding.value) return
      el.classList.add('is-active')
    })
  },
}
export const hoverSimulateTest = {
  bind(el, { value: { method } }, vnode) {
    el.addEventListener('mouseover', () => {
      const siblings = Array.from(vnode.elm.offsetParent.children)
      siblings.forEach(item => item.getElementsByClassName(vnode.elm.classList[0])[0].classList.remove('is-active'))
      el.classList.add('is-active')
      method()
    })
  },
}

export const toggleMenu = {
  bind(el) {
    el.addEventListener('click', () => {
      // const overlay = document.getElementById('menu-overlay')
      const menu = document.getElementById('fat-menu')
      const header = document.getElementById('header-wrap')
      const filterIcon = [...el.getElementsByClassName('filterIcon')]
      const [btn] = el.children[0].children
      const [headerTopEl] = [...document.getElementsByClassName('un-header_top')]
      const marquees = [...document.getElementsByClassName('marquee')].map(e => e.offsetHeight).reduce((a, b) => a + b, 0);
      const headerTop = header.getBoundingClientRect().top + window.scrollY;
      const isHeaderAtTop = (40 + marquees) === Math.round(headerTop);
      if (isHeaderAtTop) {
        menu.style.setProperty('--top', `${header.offsetHeight + headerTopEl.offsetHeight + marquees}px`)
      } else {
        menu.style.setProperty('--top', `${header.offsetHeight}px`)
      }
      if (el.classList.contains('is-opened')) {
        el.classList.remove('is-opened')
        el.firstChild.classList.remove('is-active')
        menu.classList.remove('is-active')
        // overlay.classList.add('is-hidden')
        filterIcon.forEach(icon => icon.classList.remove('open'))
        btn.classList.remove('catalog-burger-menu--opened')
        btn.classList.add('catalog-burger-menu--closed')
        document.body.style.overflow = ''
        return
      }
      // eslint-disable-next-line no-underscore-dangle
      window.app.__vue__.getMenu()
      btn.classList.remove('catalog-burger-menu--closed')
      btn.classList.add('catalog-burger-menu--opened')
      el.classList.add('is-opened')
      el.firstChild.classList.add('is-active')
      menu.classList.add('is-active')
      filterIcon.forEach(icon => icon.classList.add('open'))
      document.body.style.overflow = 'hidden'
      // overlay.classList.remove('is-hidden')
    })
  },
}
const remover = () => {
  const overlay = document.getElementById('menu-overlay')
  const menu = document.getElementById('fat-menu')
  const triggers = Array.from(document.getElementsByClassName('un-catalog-btn'))
  triggers.forEach(b => {
    b.classList.remove('is-opened')
    b.firstChild.classList.remove('is-active')
  })
  overlay.classList.add('is-hidden')
  menu.classList.remove('is-active')
  menu.classList.remove('is-hovered')
  document.body.style.overflow = ''
}

export const closeMenu = {
  bind(el) {
    el.addEventListener('mouseenter', () => {
      const menu = document.getElementById('fat-menu')
      if (menu.classList.contains('is-hovered')) {
        remover()
      }
    })
    el.addEventListener('click', () => {
      remover()
    })
  },
}

const ZERO = 0
// const OFFSET = 24
const hoverEffect = async (el, vnode) => {
  if (el.classList.contains('is-active')) return
  // eslint-disable-next-line no-underscore-dangle
  const child = vnode.elm.lastChild.__vue__
  await child.getAttributes()
  if (child.list && child.list.attributes && !child.list.attributes.length) return
  // let hover = el.getElementsByClassName('simple-hover')[0]
  // let body = el.getElementsByClassName('other-info')[0]
  // console.dir(body)
  // hover.style.marginBottom = `-${body.offsetHeight + OFFSET}px`
  // hover.style.height = `-${body.offsetHeight + OFFSET}px`
  el.classList.add('is-active')
}
const antiHoverEffect = (el, vnode) => {
  // eslint-disable-next-line no-underscore-dangle
  const child = vnode.elm.lastChild.__vue__
  child.clearRequest()
  const [hover] = el.getElementsByClassName('simple-hover')
  el.classList.remove('is-active')
  if (hover) hover.style.marginBottom = ZERO
}
const clearAllHovers = () => new Promise(res => {
  const cards = Array.from(document.getElementsByClassName('un-product-card'))
  cards.forEach(antiHoverEffect)
  res(true)
})

const getLink = el => el.getElementsByClassName('product__link is-active')[0].dataset.href

const goToProductPage = (el, e) => {
  if (
    el.classList.contains('is-active') &&
    e.target.classList.contains('product__link')
  ) {
    getLink(el)
    // window.location.href = getLink(el)
  }
}

// product card

export const cardHover = {
  bind(el, binding, vnode) {
    if (!binding.value) return
    if (
      navigator.maxTouchPoints > ZERO ||
      navigator.msMaxTouchPoints > ZERO
    ) {
      el.addEventListener('click', e => {
        goToProductPage(el, e)
        clearAllHovers().then(() => hoverEffect(el, vnode))
      })
      return
    }
    el.addEventListener('click', e => goToProductPage(el, e))

    el.addEventListener('mouseenter', () => {
      hoverEffect(el, vnode)
    })
    el.addEventListener('mouseleave', () => {
      antiHoverEffect(el, vnode)
    })
  },
}

export const productImgsMiniCards = () => {
  const arr = [...document.getElementsByClassName('product-mini-img')]
  arr.forEach(el => el.classList.remove('is-active'))
}

export const eventHandler = () => {
  const event = navigator.maxTouchPoints > ZERO || navigator.msMaxTouchPoints > ZERO ? 'click' : 'mouseenter'
  return event
}

const imageSourceReplacer = (value, el) => {
  const target = document.getElementById('product-img')
  const [img] = target.getElementsByTagName('img')
  const [source] = target.getElementsByTagName('source')
  img.src = value.origin
  img.alt = el.dataset.alt
  source.srcset = value.webp
  productImgsMiniCards()
  el.classList.add('is-active')
}

export const productImage = {
  bind(el, binding) {
    const event = eventHandler()
    el.addEventListener(event, () => {
      imageSourceReplacer(binding.value, el)
    })
  },
}
export const categoriesMenu = {
  bind(node) {
    const items = Array.from(node.getElementsByClassName('js-categories-item'))
    const contentItems = Array.from(node.getElementsByClassName('js-categories-content'))
    const isMobile = window.matchMedia('(max-width: 1200px)').matches

    let activePathIds = new Set()

    const setEquals = (a, b) => {
      if (a.size !== b.size) return false
      // eslint-disable-next-line no-restricted-syntax
      for (const v of a) {
        if (!b.has(v)) return false
      }
      return true
    }

    const buildPathFromItem = startItem => {
      const pathIds = new Set()
      let current = startItem

      while (current) {
        const { nodeId } = current.dataset
        if (!nodeId) break

        pathIds.add(nodeId)

        const { parentId } = current.dataset
        if (!parentId) break

        current = items.find(i => i.dataset.nodeId === parentId) || null
      }

      return pathIds
    }

    const applyActivePath = pathIds => {
      activePathIds = pathIds

      items.forEach(item => {
        const { nodeId } = item.dataset
        const shouldBeActive = nodeId && activePathIds.has(nodeId)
        item.classList.toggle('is-active', !!shouldBeActive)
      })

      contentItems.forEach(content => {
        const { nodeId } = content.dataset
        const shouldBeActive = nodeId && activePathIds.has(nodeId)
        content.classList.toggle('is-active', !!shouldBeActive)
      })

      node.classList.toggle('is-active', activePathIds.size > ZERO)
    }

    const clearActivePath = () => {
      if (activePathIds.size === ZERO) return

      activePathIds = new Set()

      items.forEach(item => item.classList.remove('is-active'))
      contentItems.forEach(content => content.classList.remove('is-active'))
      node.classList.remove('is-active')
    }

    node.addEventListener('mouseover', () => {
      const isStatic = 'true' === node.dataset.static

      if (isStatic) {
        const nodes = Array.from(document.getElementsByClassName('js-categories'))
        const mainNode = nodes.find(n => 'true' !== n.dataset.static)

        if (mainNode) {
          mainNode.classList.add('is-active')
          mainNode.style.setProperty('--offset', `${node.offsetWidth}px`)
        }
      }
    })

    const handleDesktopHover = item => {
      const newPath = buildPathFromItem(item)
      applyActivePath(newPath)
    }

    const handleMobileClick = item => {
      const newPath = buildPathFromItem(item)

      if (setEquals(newPath, activePathIds)) {
        clearActivePath()
      } else {
        applyActivePath(newPath)
      }
    }

    const handleMouseLeaveRoot = e => {
      if (!node.contains(e.relatedTarget)) {
        clearActivePath()
      }
    }
    if (isMobile) {
      items.forEach(item => {
        item.addEventListener('click', event => {
          event.preventDefault()
          handleMobileClick(item)
        })
      })
    } else {
      items.forEach(item => {
        item.addEventListener('mouseenter', () => handleDesktopHover(item))
      })

      node.addEventListener('mouseleave', handleMouseLeaveRoot)
    }
  },
}

export const menuButton = {
  bind(node) {
    node.addEventListener('click', () => {
      const nodes = Array.from(document.getElementsByClassName('js-categories'))
      const mainNode = nodes.find(n => 'true' !== n.dataset.static)
      const contentItems = Array.from(mainNode.getElementsByClassName('js-categories-content'))
      const items = Array.from(mainNode.getElementsByClassName('js-categories-item'))

      const findContent = item => contentItems.find(c => c.dataset.child === item.dataset.parent) || null

      mainNode.classList.toggle('is-active')
      mainNode.style.setProperty('--offset', `${mainNode.getBoundingClientRect().top}px`)
      node.classList.toggle('is-active')

      items[0].classList.add('is-active')

      const content = findContent(items[0])

      if (content) {
        content.classList.add('is-active')
      }
    })
  },
}

export default {
  cardHover,
  toggleActivity,
  toggleMenu,
  closeMenu,
  hoverSimulate,
  hoverSimulateTest,
  productImage,
  categoriesMenu,
  menuButton,
}
